import { useEffect } from "react"

export function useLocale() {
  const locale = "tr"
  const direction = "ltr" as const
  const isRTL = false

  useEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = direction

    document.body.classList.remove("font-lato", "font-cairo")
    document.body.classList.add("font-inter")
  }, [])

  return {
    locale,
    direction,
    isRTL,
  }
}
